import { FunctionsClient } from '@supabase/functions-js';

// supabase-js solo dice «Edge Function returned a non-2xx status code»: el motivo real viene en el cuerpo de la respuesta de la función.
// Este archivo hace que TODA llamada a una función de Supabase (functions.invoke) deje el motivo real en `error.message`, así los avisos
// de pantalla que ya existen lo muestran sin tocar cada pantalla. Formato: «explicación en claro [función · HTTP 422: texto original]».
const KNOWN = [
  [/already (been )?registered|already exists|email_exists/i, 'Ya existe un usuario de acceso con ese correo (puede ser un administrador, un empleado u otro cliente, o un acceso que quedó sin enlazar)'],
  [/password (should|must|is too)|weak.?password|least \d+ characters/i, 'La contraseña no es válida: usa al menos 6 caracteres'],
  [/invalid.*(jwt|token)|jwt expired|sesión inválida/i, 'Tu sesión venció: cierra sesión y vuelve a entrar'],
];

/** Texto para mostrar a partir del error que devuelve functions.invoke. Nunca lanza. */
export async function explainFunctionError(error, name = 'la función') {
  const original = error?.message || '';
  const res = error?.context;
  const status = res?.status;
  if (!res || typeof res.clone !== 'function') {
    // Sin respuesta: no llegó a la función (no publicada, sin red o CORS)
    return /Failed to send|Failed to fetch|FunctionsFetchError|NetworkError/i.test(original)
      ? `No se pudo contactar a la función ${name}: puede no estar publicada en Supabase, o no hay red [${original}]`
      : original;
  }
  let raw = '';
  try { raw = await res.clone().text(); } catch { /* sin cuerpo */ }
  let detail = raw;
  try { const j = JSON.parse(raw); detail = j.error || j.msg || j.message || j.error_description || raw; } catch { /* texto plano */ }
  detail = String(detail || '').replace(/\s+/g, ' ').trim().slice(0, 300);
  const tech = `${name} · HTTP ${status}${detail ? `: ${detail}` : ''}`;
  let plain = '';
  if (/worker boot error|BOOT_ERROR|No such file/i.test(detail)) plain = 'La función está mal publicada en Supabase (faltan sus archivos)';
  else if (status === 404) plain = 'La función no está publicada en Supabase';
  else if (status === 401) plain = KNOWN.find(([re]) => re.test(detail))?.[1] || 'Tu sesión venció: cierra sesión y vuelve a entrar';
  else if (status === 403) plain = 'Tu usuario no es administrador de la plataforma, así que no puede hacer esto';
  else plain = KNOWN.find(([re]) => re.test(detail))?.[1] || '';
  return plain ? `${plain} [${tech}]` : (detail ? `${detail} [${name} · HTTP ${status}]` : `${original || 'La función respondió con error'} [${name} · HTTP ${status}]`);
}

let patched = false;
export function showRealFunctionErrors() {
  if (patched || !FunctionsClient?.prototype?.invoke) return;
  patched = true;
  const invoke = FunctionsClient.prototype.invoke;
  FunctionsClient.prototype.invoke = async function patchedInvoke(name, options) {
    const result = await invoke.call(this, name, options);
    if (result?.error) {
      try { result.error.originalMessage = result.error.message; result.error.message = await explainFunctionError(result.error, name); } catch { /* se queda el mensaje original */ }
    }
    return result;
  };
}
